module.exports = __webpack_public_path__ + "static/media/1.0ab390f2.jpg";